var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class AtenUsb {
    constructor(socket, log) {
        this.socket = socket;
        this.products = {
            '-LdjivRfDs-rpVBgRBT9': { name: 'CS1924M', openResponse: 'open Command OK' },
            '-LdjjWd-v7kW88A8WOfE': { name: 'CS1922M', openResponse: 'open Command OK' },
            '-Ldjk2j6ssn9tB5isl63': { name: 'US3344I', openResponse: 'Command incorrect' },
        };
        this.product = this.products['-LdjivRfDs-rpVBgRBT9'];
        this.asyncHandlers = [
            {
                name: 'ping',
                regExp: /open/i,
                callback: (match) => {
                    this.socket.send(`${this.product.openResponse}`);
                },
            },
            {
                name: 'videoMatrixRoutesSet',
                regExp: /sw (i|p)0(.+)/i,
                callback: (match) => {
                    this.socket.send(`Command OK`);
                },
            },
        ];
    }
    onConfigure(config) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.product = this.products[(_a = config.modelNumber) !== null && _a !== void 0 ? _a : '-LdjivRfDs-rpVBgRBT9'];
        });
    }
}
AtenUsb.emulatorType = 'socketEmulator';
AtenUsb.key = '-LsCiehySCqbjfEnuknG';
